export default __webpack_public_path__ + "static/img/vogue_scene_animated_0112.2fa6149.jpg";